import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { db } from "../../firebase";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";

export default function AgentSourcesDialog({
  open,
  onClose,
  tenantId,
  agentId,
}) {
  const [sources, setSources] = useState([]);
  const [newUrl, setNewUrl] = useState("");

  useEffect(() => {
    if (!tenantId || !agentId) return;
    const ref = collection(
      db,
      "tenants",
      tenantId,
      "agents",
      agentId,
      "sources"
    );
    const unsub = onSnapshot(ref, (snap) =>
      setSources(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
    return unsub;
  }, [tenantId, agentId]);

  const addSource = async () => {
    if (!newUrl.trim()) return;
    await addDoc(
      collection(db, "tenants", tenantId, "agents", agentId, "sources"),
      {
        type: newUrl.endsWith(".pdf") ? "pdf" : "url",
        name: newUrl.split("/").pop(),
        url: newUrl,
        uploadedAt: new Date(),
      }
    );
    setNewUrl("");
  };

  const removeSource = async (id) => {
    await deleteDoc(
      doc(db, "tenants", tenantId, "agents", agentId, "sources", id)
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Knowledge Sources</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Add PDF or URL"
          value={newUrl}
          onChange={(e) => setNewUrl(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && addSource()}
          sx={{ mt: 1, mb: 2 }}
        />
        <List>
          {sources.map((s) => (
            <ListItem
              key={s.id}
              secondaryAction={
                <IconButton onClick={() => removeSource(s.id)}>
                  <DeleteIcon />
                </IconButton>
              }
            >
              <ListItemText
                primary={s.name}
                secondary={`${s.type.toUpperCase()} – ${new Date(
                  s.uploadedAt.seconds * 1000
                ).toLocaleString()}`}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={addSource} variant="contained">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
